import { Model } from '@/models'
import { ConsultantNotificationEmailAddressService } from '@/services'

export class ConsultantNotificationEmailAddress extends Model {
    /**
     * Create a ConsultantNotificationEmailAddress model wrapper.
     * @param {Object} data - Object holding the field values.
     */
    constructor (data) {
        super()
        Model.initializeFields(this, [
            'id',
            'email',
            'notificationEmitters',
        ], data)
    }

    static get service () { return ConsultantNotificationEmailAddressService }

    /**
     * Create a new consultantNotificationEmailAddress.
     * @param {Object} variables - The values used to create the consultantNotificationEmailAddress.
     * @param {string} variables.consultantId - The ID of the consultant
     * @param {Object} variables.consultantNotificationEmailAddress - The email address data
     * @param {string} variables.consultantNotificationEmailAddress.email - The email address
     * @param {Array<string>} variables.consultantNotificationEmailAddress.notificationEmitters - Array of notification emitter types
     * @returns {Promise<*>}
     */
    static create (variables) {
        return ConsultantNotificationEmailAddressService.create(variables)
    }

    /**
     * Update this consultantNotificationEmailAddress.
     * @param {Object} variables - The values used to update the consultantNotificationEmailAddress.
     * @param {string} variables.email - The email address
     * @param {Array<string>} variables.notificationEmitters - Array of notification emitter types
     * @returns {Promise<*>}
     */
    update (variables) {
        return ConsultantNotificationEmailAddressService.update({
            id: this.id,
            ...variables,
        }).then(consultantNotificationEmailAddress => {
            Object.assign(this, consultantNotificationEmailAddress)
            return consultantNotificationEmailAddress
        })
    }

    /**
     * Delete this consultantNotificationEmailAddress.
     * @param {boolean} forceDelete - Whether to force deletion even if the email address is used in notification emitters
     * @returns {Promise<*>}
     */
    delete (forceDelete = false) {
        return ConsultantNotificationEmailAddressService.delete(this.id, forceDelete)
    }
}
